<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <material-card
          :elevation="0"
          full-width
        >
          <template #header>
            <v-row no-gutters align="center">
              <v-col>
                <p class="headline font-weight-regular mb-2" >
                {{ $t('quotaManagement')}}
                </p>
              </v-col>

              <v-col cols="auto">
                <Icon
                :tooltipText="$t('quotaSubtitle')"
                :small="false"
                tooltipColor="primary"
                iconColor="white"
                icon="mdi-help-circle-outline"/>
              </v-col>
            </v-row>
            <v-spacer/>
          </template>
          <v-tabs v-model="tab" touchless>
            <v-tab>
              {{ $t('inbound') }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <InboundQuota />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Quotas',

  components: {
    InboundQuota: () => import('@/components/quota/InboundQuota.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    tab: 0
  })
}
</script>
